"use client";

import { useRouterBack } from "@/shared-web.ui/hook.use-router-back";
import { Cart } from "@/stf.m.checkout/feat.cart";

export default function Page() {
  const { routerBack } = useRouterBack();

  return (
    <Cart
      open
      onOpenChange={routerBack}
    />
  );
}
